<template>
  <div class="elite-tabs-wrapper-content">
    <log-list-table :filterSubject="nuveiCard" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "nuvei-card-view-logs",

  components: { LogListTable },

  props: ["nuveiCard"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
